import { Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        py: 1,
        bgcolor: "background.paper",
        textAlign: "center",
        borderTop: "1px solid",
        borderColor: "divider",
        mt: 6,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        © Vivek Rathi 2025
      </Typography>
    </Box>
  );
};

export default Footer;
